import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { ALTERAR_VEICULO_ITINERARIO } from '../types';

export default function alterarVeiculoItinerario (itinerario) {
  const url = `${URL}/itinerario/alterar-veiculo`;
  return dispatch => axios.post(url, itinerario, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ALTERAR_VEICULO_ITINERARIO,
        payload: response
      })
  );
}
